// Generated by scripts/build-ui-icons.mjs.
export { BeerStein as default } from "../ui/glyphs-1";
